/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useEffect, useState } from "react";
import "../../../assets/styles/custom-style.css";
import SearchInput from "../../../component/core/Searchinput";
import { useAuth } from "../../../auth";

import { getOrderStatus, getUser, getHistory } from "../core/_requests";

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { UUID } from "crypto";
import Pagination from "../../../component/Pagination";

interface History {
  primaryId: any;
  orderId: string;
  orderDate: string;
  user: {
    userName: string;
  };
  orderstatus: {
    orderStatus: string;
  };
  netValue: number;
  amount: number;
  chefTips: number;
  tax: number;
  couponAmount: number;
}

interface UserList {
  uuid: UUID;
  userName: string;
}

interface OrderStatusList {
  id: string | number | readonly string[] | undefined;
  uuid: UUID;
  name: string;
}

const OrderHistory = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [listHistory, setlistHistory] = useState<History[]>([]);
  const [user, setUser] = useState<UserList[]>([]);
  const [orderStatus, setOrderStatus] = useState<OrderStatusList[]>([]);
  const [userId, setUserId] = useState("");
  const [orderStatusId, setOrderStatusId] = useState("");
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const { order } = useParams();
  const decodedOrder = decodeURIComponent(order || "");
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dataSearch = searchParams.get("search");
  const chefId = currentUser?.uuid;
  const data = {
    search: dataSearch,
    orderstatusId: orderStatusId,
    userId: userId,
  };
    useEffect(() => {
    if (dataSearch !== undefined) {
            setSearch(search);
      getHistory(chefId, data)
        .then((res) => {
                    setlistHistory(res?.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching dishes:", error);
          setLoading(false);
        });
    }
  }, [decodedOrder]);

  useEffect(() => {
    getUser()
      .then((res) => {
                setUser(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching financial year:", error);
      });
  }, []);

  useEffect(() => {
    getOrderStatus()
      .then((res) => {
        setOrderStatus(res?.data?.data);
              })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);

  const clickApply = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setCurrentPage(1);
    const data = {
      search: search,
      orderstatusId: orderStatusId,
      userId: userId,
    };
    try {
      await getHistory(chefId, data).then((res) => {
        setlistHistory(res?.data);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching coupon:", error);
      setLoading(false);
    }
  };

  const clickCancel = () => {
    setUserId("");
    setOrderStatusId("");
    if (dataSearch !== undefined) {
            setSearch(search);
      getHistory(chefId, data)
        .then((res) => {
                    setlistHistory(res?.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching dishes:", error);
          setLoading(false);
        });
    }
  };

  //pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = listHistory.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(listHistory.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= pages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    const isActive = number === currentPage;

    let pageNumberContent;

    if (
      number === 1 ||
      number === pages ||
      (number >= currentPage - 1 && number <= currentPage + 1)
    ) {
      pageNumberContent = (
        <li
          key={number}
          className={`page-item ${number === currentPage ? "active" : ""}`}
        >
          <a
            className={`page-link cursorPointer ${number === currentPage ? "active" : ""
              }`}
            onClick={() => setCurrentPage(number)}
          >
            {number}
          </a>
        </li>
      );
    } else if (number === 2 || number === pages - 1) {
      // Add links for second and second-to-last pages
      pageNumberContent = (
        <li key={number} className="page-item">
          <a
            className="page-link cursorPointer"
            onClick={() => setCurrentPage(number)}
          >
            {number}
          </a>
        </li>
      );
    } else if (number === 3 && currentPage > 4) {
      // Add ellipsis before the link to the second page
      pageNumberContent = (
        <li key={number} className="page-item">
          <span className="ellipsis">...</span>
        </li>
      );
    } else if (number === pages - 2 && currentPage < pages - 3) {
      // Add ellipsis before the link to the second-to-last page
      pageNumberContent = (
        <li key={number} className="page-item">
          <span className="ellipsis">...</span>
        </li>
      );
    }

    return pageNumberContent;
  });


  const statusColors: { [key: string]: string } = {
    ordered: "black",
    preparing: "orange",
    ready: "blue",
    track: "purple",
    delivered: "green",
    canceled: "red",
    "canceled by admin": "red",
    failed: "grey",
    "canceled by user": "pink",
    "accepted ": "lightblue",
    "accepted driver": "lightgreen",
    "canceled by driver": "darkred",
    "On the way to user": "lightblue",
  };

  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            {/*  */}
            <section className="row main-content">
              <div className="title mb-3">
                <h3 className="mb-0">History ({listHistory?.length})</h3>
              </div>
              <div className="col-12 title-btm">
             <SearchInput
                 value={search}
                     onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                  onKeyUp={clickApply}
                  />
                  
                
              </div>
              <div className="filter-sec mt-2 mt-md-4">
                <form
                  noValidate
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="row gx-3">
                    <div className="col-md-4">
                      <label className="form-label">Order Status</label>
                      <select
                        className="form-select form-control mb-0"
                        onChange={(e) => setOrderStatusId(e.target.value)}
                      >
                        <option value="">All</option>
                        {orderStatus.map((item, i) => {
                          //
                          return (
                            <option value={item?.id} key={i}>
                              {item?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">User</label>
                      <select
                        className="form-select form-control mb-0"
                        onChange={(e) => setUserId(e.target.value)}
                      >
                        <option value="">All</option>
                        {user.map((item, i) => {
                          return (
                            <option value={item?.uuid} key={i}>
                              {item?.userName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-4 d-flex align-items-center justify-content-lg-end justify-content-between pt-md-4 pt-3 filter-btn-sec">
                      <button
                        className="btn btn-cancel rounded-5 small me-2 mt-1"
                        onClick={clickCancel}
                      >
                        Clear
                      </button>
                      <button
                        className="btn btn-primary rounded-5 small mt-1"
                        onClick={clickApply}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div className="table-wrap mt-4">
                <table className="table custom-table">
                  <thead className="">
                    <tr>
                      <th>S.No</th>
                      <th>Order Id</th>
                      <th>User Name</th>
                      <th>Order Status</th>
                      <th>Date</th>
                      <th>Amount ($)</th>
                      {/* <th>Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, i) => {
                        
                        return (
                          <tr key={i}>
                            <td>
                              <p>{1 + i}</p>
                            </td>
                            <td>
                              <div className="dish">
                                <Link
                                  to={`/orders/order-details/${item.primaryId}`}
                                  className="text-decoration-none text-primary hover-text-primary"
                                >
                                  <p className="ms-1 mb-0">{item?.orderId}</p>
                                </Link>
                              </div>
                            </td>
                            <td>
                              <p>{item?.user?.userName} </p>
                            </td>
                            <td>
                              <p className="mb-0 fw-bold" style={{
                              color: statusColors[item?.orderstatus?.orderStatus || ""],
                            }}>
                                {item?.orderstatus?.orderStatus === "ready"
                                  ? "Ready"
                                  : item?.orderstatus?.orderStatus ===
                                    "preparing"
                                    ? "Preparing"
                                    : item?.orderstatus?.orderStatus === "track"
                                      ? "Track"
                                      : item?.orderstatus?.orderStatus}
                              </p>
                            </td>

                            <td>
                              <p className="mb-0">{item?.orderDate} </p>
                            </td>
                            <td> ${(item?.netValue).toFixed(2)}</td>
                          </tr>
                        );
                      })
                    ) : loading ? (
                      <tr>
                        <td colSpan={8} className="text-center">
                          Loading...{" "}
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td colSpan={8} className="text-center">
                         No Orders Yet – Stay Tuned!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <Pagination
                data={listHistory}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default OrderHistory;
